import heroDesktopImage from '../../images/shipplay/backgrounds/desktop/generic-cruises-hero-background-20251106.jpg';
import heroMobileImage from '../../images/shipplay/backgrounds/mobile/generic-cruises-hero-background-20251106.jpg';
import navLogo from '../../images/shipplay/logos/generic-cruise-logo2.svg';
import footerLogo from '../../images/shipplay/logos/Ship&Play_FullColor_DarkBG.svg';
import shipPlayLogo from '../../images/shipplay/logos/Ship&Play_FullColor_DarkBG.svg';

// 20250915 new images
import journeyImage from '../../images/shipplay/generic_cruises/cruise-journey-20250918.jpg';
import ctaBackgroundImage from '../../images/shipplay/generic_cruises/cruise-cta-background-20250918.jpg';
import stepIcon1 from '../../images/shipplay/cruise-step-icon-1.png';
import stepIcon2 from '../../images/shipplay/cruise-step-icon-2.png';
import stepIcon3 from '../../images/shipplay/cruise-step-icon-3.png';

const partnerConfig = {
  'name': 'Cruises',
  'path': 'cruises',
  'brand': 'shipplay',
  'template': 'modern', // This flags the component to use new structure
  'subdomain': null,
  'couponCode': '',
  'defaultCTAPath': '/pricing',
  'showNavExtraLinks': false,
  'logoClasses': 'w-60 sm:w-64 md:w-80 lg:w-auto max-w-80',
  'logoURL': '/cruises',
  'defaultMenuItems': [
    { 'name': 'Track', 'path': '/track' },
    { 'name': 'How it works', 'path': 'cruises-steps' },
    { 'name': 'Ship now', 'path': 'leading-tight' }
  ],
  'images': {
    'backgroundMobile': heroMobileImage,
    'backgroundDesktop': heroDesktopImage,
    'heroBackgroundPosition': '0% 100%',
    'navLogo': navLogo,
    'footerLogo': footerLogo,
    'shipPlayLogo': shipPlayLogo
  },
  'sections': [
    {
      'type': 'hero',
      'title': 'Smooth Sailing Starts Here',
      'subtitle': 'Ship your bags to and from your cruise for relaxed, hassle-free travel.',
      'backgroundImage': heroDesktopImage,
      'backgroundPosition': '0% 100%',
      'customClass': 'cruises-hero',
      'showQuickQuote': true
    },
    {
      'type': 'journey',
      'title': 'Enjoy the journey - let us take care of your luggage',
      'description': [
        'Getting to your cruise should be as enjoyable as the cruise itself. ' +
        'Forget lugging your suitcases through the airport, waiting in baggage lines, ' +
        'and worrying about your luggage making the connection. <br><br>' +
        '<strong>There&apos;s a better way.</strong> Trust us with your cruise ship luggage shipping. ' +
        'Travel hands-free and carefree to your cruise knowing your bags will be waiting for you. ' +
        'Then, when your voyage ends, send your bags back just as easily—souvenirs and all.'
      ],
      'image': journeyImage,
      'imageAlt': 'Beautiful cruise destination',
      'features': [
        {
          'title': 'Have your bags picked up at your home',
          'description': ' - or drop them off locally at our trusted carrier partner.'
        },
        {
          'title': 'Meet your bags where you want them',
          'description': ' - whether on board or at your hotel before you set sail.'
        },
        {
          'title': 'Enjoy access to our dedicated cruise concierge team',
          'description': ' - our specialists are ready to assist 7 days a week.'
        }
      ],
      'customClass': 'cruises-journey'
    },
    {
      'type': 'steps',
      'title': 'Three steps to stress-free travel',
      'subtitle': 'See how simple shipping can be.',
      'backgroundColor': 'bg-[#1C2938] color-white',
      'steps': [
        {
          'title': 'Book easily',
          'icon': stepIcon1,
          'description': 'Place your order online, by phone, or have your travel advisor arrange it for you. '
        },
        {
          'title': 'Pack your bags',
          'icon': stepIcon2,
          'description': 'Pack as you would for a flight and attach the provided labels to your bags. ' +
            'We\'ll handle the rest.'
        },
        {
          'title': 'Meet Your bags on Board',
          'icon': stepIcon3,
          'description': 'Skip baggage claim and the airport hassle. Your luggage will be there when you arrive.'
        }
      ],
      'customClass': 'cruises-steps'
    },
    {
      'type': 'expectations',
      'title': 'What you can expect',
      'subtitle': 'with Ship&Play',
      'backgroundColor': 'bg-white',
      'expectations': [
         {
          'title': 'Shipping made easy',
          'description': 'We\'ll send you pre-printed labels, customs forms, ' + 
                        'if needed, <br class="hidden md:block" />and detailed directions for smooth sailing.'
        },
        {
          'title': 'On-time guarantee',
          'description': 'Travel relaxed knowing your bags will be there, and track <br class="hidden md:block" />' + 
                          'their progress in real time from just about anywhere.'
        },
        {
          'title': 'Concierge cruise team',
          'description': 'Our dedicated team will handle any customs paperwork <br class="hidden md:block" />' +
                         'and is available to assist you 7 days a week.'
        },
        {
          'title': 'Complimentary insurance',
          'description': 'We offer $500 of coverage at no cost to you, or you can <br class="hidden md:block" />' +
                        'explore additional options.'
        }
      ],
      'customClass': 'cruises-expectations'
    },
    {
      type: 'video',
      title: 'Watch <span>how it works</span>',
      description: 'See how easy it is to ship your bags to your cruise with Ship&Play. ' + 
                   'Enjoy the journey from start to finish.',
      buttonText: 'Watch on YouTube',
      videoUrl: 'https://www.youtube.com/watch?v=sQTJHRERPhg',
      backgroundColor: '#F5F5F5'
    },
    {
      'type': 'cta',
      'title': 'Goodbye baggage. Hello vacation.',
      'subtitle': '',
      'buttonText': 'Get started',
      'buttonLink': '/pricing',
      'backgroundImage': ctaBackgroundImage,
      'backgroundPosition': 'center center',
      'customClass': 'cruises-cta'
    },
    {
      'type': 'contact',
      'title': 'Concierge team',
      'description': 'If you need help booking your cruise shipment, your plans have changed, ' + 
                     'or you have a question, a dedicated cruise concierge team is available for ' +
                     'your convenience. Reach out by phone, text, email, or chat - whatever works best for you.',
      'backgroundColor': 'bg-gray-50',
      'contactInfo': {
        'phone': '(855) 792-7529',
        'email': 'cruise@shipplay.com',
        'hours': [
          'Mon - Fri: 8 AM - 8 PM EST',
          'Sat: 9 AM - 5 PM EST',
          'Sun: 9 AM - 6 PM EST'
        ]
      },
      'customClass': 'cruises-contact'
    }
  ],
  'footer': {
    'showTerms': true,
    'termsTitle': 'Any Questions?',
    'defaultTerms': 'Our dedicated customer support team is here for you every ' +
      'single day of the week. Should you have any questions or need additional ' +
      'information, please call or text us at (855) 566-2085.',
    'showNewsletter': true,
    'customClass': 'cruises-footer'
  },
  'footerLogoSize': 'w-[150px] lg:w-[150px]',
  'footerLogo': footerLogo,
  'supportPhoneNumber': '(855) 792-7529'
};

export default partnerConfig;
